import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Remarkable } from "remarkable";
import useCommonApi from "../hooks/common-apis";
import EmojiPicker from "emoji-picker-react";
import { Popover } from "flowbite-react";
import SocialConnectModal from "./SocialConnectModal";
import ScheduleSocialPostModal from "./ScheduleSocialPostModal";
import PixelMediaPopup from "./PixelMediaPopup";
import { Tooltip } from "react-tooltip";
import { clog } from "../lib/utils";

function TweetCard({
  headline,
  stringOutput,
  wholeStringOutput,
  cardNumber,
  profile,
  setopenSuccessModal,
  setopenFailureModal,
  setsuccessFailureMessage,
  handleTwitterLogin,
  mediaObj,
  media_arr,
  loader,
  isTweetPosted,
  content_id,
  setStringOutput,
  setstringWords,
  connectModal,
  setConnectModal,
  callSaveApi,
  tweet,
  settweets,
  tweetsModified,
  settweetsModified,
  edited,
  setedited,
}) {
  const navigate = useNavigate();
  const { getRecentFiles, callUpdateToFileApi } = useCommonApi();
  function checkStyle(text, type) {
    const firstChar = Array.from(text)[0];
    const code = firstChar?.codePointAt(0);

    switch (type) {
      case "bold":
        return code >= 0x1d400 && code <= 0x1d433;
      case "italic":
        return code >= 0x1d434 && code <= 0x1d467;
      case "boldItalic":
        return code >= 0x1d468 && code <= 0x1d49b;
      case "underline":
        return text.includes("\u0332");
      case "strikethrough":
        return text.includes("\u0336");
      default:
        return false;
    }
  }
  // const applyFormatting = (type) => {
  //   clog(
  //     contentEditableRef?.current,
  //     contentEditableRef?.current?.selectionStart,
  //     "editor ref"
  //   );
  //   const { selectionStart, selectionEnd } = contentEditableRef?.current;
  //   let text = contentEditableRef?.current?.textContent;
  //   const selectedText = text.substring(selectionStart, selectionEnd);
  //   clog(selectedText, "selected text");

  //   if (!selectedText) return;

  //   const normalText = toNormal(selectedText);
  //   const isFormatted = normalText !== selectedText;
  //   clog(isFormatted, "isFormatted", selectedText, normalText);
  //   const isMatchingStyle = checkStyle(selectedText, type);
  //   const formattedText =
  //     isFormatted && isMatchingStyle
  //       ? normalText
  //       : formatText(normalText, type);

  //   const updatedText =
  //     text.substring(0, selectionStart) +
  //     formattedText +
  //     text.substring(selectionEnd);
  //   clog(updatedText, "updated test");
  //   contentEditableRef.current.textContent = updatedText;
  //   contentEditableRef?.current?.focus();
  //   // contentEditableRef?.current?.setSelectionRange(
  //   //   selectionStart,
  //   //   selectionStart + formattedText.length
  //   // );
  //   const selection = window.getSelection();
  //   const range = document.createRange();
  //   range.setStart(contentEditableRef.current.firstChild, selectionStart);
  //   range.setEnd(
  //     contentEditableRef.current.firstChild,
  //     selectionStart + formattedText.length
  //   );
  //   selection.removeAllRanges();
  //   selection.addRange(range);
  // };
  const applyFormatting = (type) => {
    if (tweet?.id?.length > 0) {
      return;
    }
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    const selectedText = range.toString();
    clog(selectedText, "selected text");

    if (!selectedText) return;

    const normalText = toNormal(selectedText);
    const isFormatted = normalText !== selectedText;
    clog(isFormatted, "isFormatted", selectedText, normalText);
    const isMatchingStyle = checkStyle(selectedText, type);
    const formattedText =
      isFormatted && isMatchingStyle
        ? normalText
        : formatText(normalText, type);

    // Replace the selected text with formatted text
    range.deleteContents();
    const textNode = document.createTextNode(formattedText);
    range.insertNode(textNode);

    // Move selection to the end of formatted text
    range.setStartAfter(textNode);
    range.setEndAfter(textNode);
    selection.removeAllRanges();
    selection.addRange(range);

    contentEditableRef?.current?.focus();
    setedited(true);
    settweetsModified((prev) => {
      return prev.map((item, index) => {
        if (index === cardNumber) {
          return {
            ...item,
            content: contentEditableRef.current.innerText,
          };
        }
        return item;
      });
    });
  };

  function formatText(text, type) {
    switch (type) {
      case "bold":
        return text.replace(/[A-Za-z0-9]/g, (char) => {
          if (/[A-Za-z]/.test(char)) {
            const baseCode = char >= "A" && char <= "Z" ? 0x1d400 : 0x1d41a;
            const offset = char.toUpperCase().charCodeAt(0) - 65;
            return String.fromCodePoint(baseCode + offset);
          } else {
            return String.fromCodePoint(0x1d7ce + (char.charCodeAt(0) - 48)); // Bold numbers
          }
        });

      case "italic":
        return text.replace(/[A-Za-z0-9]/g, (char) => {
          if (char === "h") return "ℎ"; // Fix for italic 'h'
          if (/[A-Za-z]/.test(char)) {
            const baseCode = char >= "A" && char <= "Z" ? 0x1d434 : 0x1d44e;
            const offset = char.toUpperCase().charCodeAt(0) - 65;
            return String.fromCodePoint(baseCode + offset);
          } else {
            return char; // Italic digits don't exist in Unicode
          }
        });

      case "boldItalic":
        return text.replace(/[A-Za-z0-9]/g, (char) => {
          if (/[A-Za-z]/.test(char)) {
            const baseCode = char >= "A" && char <= "Z" ? 0x1d468 : 0x1d482;
            const offset = char.toUpperCase().charCodeAt(0) - 65;
            return String.fromCodePoint(baseCode + offset);
          } else {
            return char; // Bold Italic digits don't exist in Unicode
          }
        });

      case "underline":
        return text
          .split("")
          .map((char) => char + "\u0332") // Add underline modifier
          .join("");

      case "strikethrough":
        return text
          .split("")
          .map((char) => char + "\u0336") // Add strikethrough modifier
          .join("");

      default:
        return text;
    }
  }

  function toNormal(text) {
    return text
      .replace(/[\uD835][\uDC00-\uDC9B]/g, (match) => {
        const codePoint = match.charCodeAt(1) - 0xdc00 + 0x1d400;

        if (codePoint >= 0x1d400 && codePoint <= 0x1d419) {
          // Bold uppercase
          return String.fromCharCode("A".charCodeAt(0) + (codePoint - 0x1d400));
        } else if (codePoint >= 0x1d41a && codePoint <= 0x1d433) {
          // Bold lowercase
          return String.fromCharCode("a".charCodeAt(0) + (codePoint - 0x1d41a));
        } else if (codePoint >= 0x1d434 && codePoint <= 0x1d44d) {
          // Italic uppercase
          return String.fromCharCode("A".charCodeAt(0) + (codePoint - 0x1d434));
        } else if (codePoint >= 0x1d44e && codePoint <= 0x1d467) {
          // Italic lowercase
          return String.fromCharCode("a".charCodeAt(0) + (codePoint - 0x1d44e));
        } else if (codePoint >= 0x1d468 && codePoint <= 0x1d481) {
          // Bold Italic uppercase
          return String.fromCharCode("A".charCodeAt(0) + (codePoint - 0x1d468));
        } else if (codePoint >= 0x1d482 && codePoint <= 0x1d49b) {
          // Bold Italic lowercase
          return String.fromCharCode("a".charCodeAt(0) + (codePoint - 0x1d482));
        }
        return match;
      })
      .replace(/ℎ/g, "h") // Fix for italic "h"
      .replace(/[\u0332\u0336]/g, ""); // Remove underline and strikethrough
  }
  function insertBulletPoint() {
    if (tweet?.id?.length > 0) {
      return;
    }
    const selection = window.getSelection();
    if (!selection.rangeCount) return;

    const range = selection.getRangeAt(0);
    const selectedText = range.toString().trim();
    const bulletUnicode = "• ";

    if (!selectedText) {
      // No text selected, insert a new bullet at the cursor position
      const bulletNode = document.createTextNode(bulletUnicode);
      range.insertNode(bulletNode);

      // Move cursor after the bullet
      range.setStartAfter(bulletNode);
      range.setEndAfter(bulletNode);
      selection.removeAllRanges();
      selection.addRange(range);
      return;
    }

    // Get the content inside the selection
    const fragment = range.cloneContents();
    const nodes = [...fragment.childNodes];

    if (nodes.length === 0) {
      // Single line or text-only selection
      const bulletText = bulletUnicode + selectedText;
      range.deleteContents();
      const textNode = document.createTextNode(bulletText);
      range.insertNode(textNode);
      range.setStartAfter(textNode);
      range.setEndAfter(textNode);
    } else {
      // Multi-paragraph selection
      const newFragment = document.createDocumentFragment();

      nodes.forEach((node, index) => {
        if (node.nodeType === Node.TEXT_NODE) {
          // If it's text, just prepend the bullet
          const bulletText = document.createTextNode(
            (index === 0 ? bulletUnicode : "\n" + bulletUnicode) +
              node.textContent.trim()
          );
          newFragment.appendChild(bulletText);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          // If it's a block element (e.g., div, p), modify its content
          const modifiedNode = node.cloneNode(true);
          modifiedNode.textContent =
            bulletUnicode + modifiedNode.textContent.trim();
          newFragment.appendChild(modifiedNode);
        }
      });

      // Replace the selected content with the new formatted content
      range.deleteContents();
      range.insertNode(newFragment);
    }

    // Restore selection and focus
    selection.removeAllRanges();
    selection.addRange(range);
    contentEditableRef?.current?.focus();
    setedited(true);
    settweetsModified((prev) => {
      return prev.map((item, index) => {
        if (index === cardNumber) {
          return {
            ...item,
            content: contentEditableRef.current.innerText,
          };
        }
        return item;
      });
    });
  }
  const convertMarkdownToFormatted = (text) => {
    let formattedText = text;

    // Handle Bold + Italic first (since it's a combination)
    formattedText = formattedText.replace(
      /(\*\*\*|___)(.*?)\1/g,
      (_, __, content) => {
        return formatText(content, "boldItalic");
      }
    );

    // Handle Bold
    formattedText = formattedText.replace(
      /(\*\*|__)(.*?)\1/g,
      (_, __, content) => {
        return formatText(content, "bold");
      }
    );

    // Handle Italic
    formattedText = formattedText.replace(
      /(\*|_)(.*?)\1/g,
      (_, __, content) => {
        return formatText(content, "italic");
      }
    );

    // Handle Underline
    formattedText = formattedText.replace(/~(.*?)~/g, (_, content) => {
      return formatText(content, "underline");
    });

    // Handle Strikethrough
    formattedText = formattedText.replace(/~~(.*?)~~/g, (_, content) => {
      return formatText(content, "strikethrough");
    });

    // Handle Code
    formattedText = formattedText.replace(/```(.*?)```/g, (_, content) => {
      return `<code>${content}</code>`;
    });

    //handle Links
    formattedText = formattedText.replace(
      /\[(.*?)\]\((.*?)\)/g,
      (_, text, url) => {
        if (url.includes("mailto") || url.includes("tel")) {
          const cleanUrl = url.replace(/^(mailto:|tel:)/, "");
          return `<span style="color:blue;">${cleanUrl}</span>`;
        } else {
          return `<a href="${url}" target="_blank" style="text-decoration:none;">${url}</a>`;
        }
      }
    );

    // Handle Bullet Points
    formattedText = formattedText.replace(/^- (.*)/g, (_, content) => {
      return `<li>${content}</li>`;
    });

    // Handle Hash Tags
    formattedText = formattedText.replace(
      /#(\w+)/g,
      (_, tag) => `<span style="color:blue;">#${tag}</span>`
    );

    // Handle Line Breaks
    formattedText = formattedText.replace(/\n/g, "<br />");

    return formattedText;
  };

  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [posting, setPosting] = useState(false);
  // const [connectModal, setConnectModal] = useState(false);
  // const [originalString, setOriginalString] = useState("");
  const [textLength, setTextLength] = useState(0);
  const [typingTimer, setTypingTimer] = useState(null);
  const [updating, setUpdating] = useState(false);
  const [schedulePostModal, setSchedulePostModal] = useState(undefined);
  const typingTimeout = 300; // Set the timeout value in milliseconds (adjust as needed)
  const [savedSelection, setSavedSelection] = useState(null);
  const [showModal, setshowModal] = useState({
    first: false,
    second: false,
    third: false,
  });
  const [popupMessage, setpopupMessage] = useState("");
  const contentEditableRef = useRef(null);
  const previousSelection = useRef(null); // Track previous selection
  const pickerRef = useRef(null);
  const textLimit = 280;
  const [media, setMedia] = useState();

  const [imagesPopup, setImagesPopup] = useState();

  // clog(stringOutput, "stringOutput in tweet card");

  // const getRemarkableText = (as) => {
  //   // let string=stringOutput?.replaceAll(/\n/g, "<br/>");
  //   const md = new Remarkable();
  //   md.set({
  //     html: true,
  //     breaks: true,
  //     linkify: true,
  //     typographer: true,
  //     quotes: "“”‘’",
  //     xhtmlOut: true,
  //     langPrefix: "language-",
  //   });
  //   const html = md.render(stringOutput || "");
  //   return html;
  // };
  clog(headline, "headline");
  async function postNewTweet(datetime, timezone, index) {
    clog(datetime);
    setPosting(true);
    let url = "";
    let data = {};
    if (headline === "Tweets") {
      url = `${process.env.REACT_APP_BASE_USER_URL}/social/twitter/post_tweet`;
      data = {
        tweet: contentEditableRef?.current?.innerText || stringOutput,
        schedule_datetime: datetime || null,
        timezone: timezone || null,
        media: tweet?.media?.url || null,
        content_id: content_id,
      };
    } else if (headline === "LinkedIn") {
      url = `${process.env.REACT_APP_BASE_SIGNIN_URL}/api/linkedin/post`;
      data = {
        message: contentEditableRef?.current?.innerText || stringOutput,
        access_token: JSON.parse(localStorage.getItem("linkedin_access"))
          ?.access_token,
        media_url: tweet?.media?.url || null,
        content_id: content_id,
      };
      if (datetime) {
        data["schedule_datetime"] = datetime || null;
        data["timezone"] = timezone || null;
      }
    } else {
      url = "";
      data = {};
    }
    clog(data, tweet?.media, "data");
    try {
      let response = await axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          jwt_token: localStorage.getItem("login_token"),
        },
        data: data,
      });
      // clog(response, "response");
      if (!response.data.error) {
        clog(response.data, "response");
        // handleContentChange({
        //   target: contentEditableRef.current,
        //   mediaObj: media,
        //   tweetPosted: {
        //     post_id: response?.data?.data?.post?.id || null,
        //     type: datetime ? "scheduled" : "posted",
        //   },
        // });
        if (headline === "Tweets") {
          callSaveApi(
            {
              content: contentEditableRef?.current?.innerText || stringOutput,
              id:
                response?.data?.data?.post?.tweet_id ||
                response?.data?.data?.post?.id,
              db_id: response?.data?.db_id,
              schedule_datetime: datetime || null,
              user_timezone: timezone || null,
              media: tweet?.media,
              type: datetime ? "scheduled" : "posted",
            },
            cardNumber,
            "twitter"
          );
        } else {
          callSaveApi(
            {
              content: contentEditableRef?.current?.innerText || stringOutput,
              id: response?.data?.response?.id,
              db_id: response?.data?.db_id,
              schedule_datetime: datetime || null,
              user_timezone: timezone || null,
              media: tweet?.media,
              type: datetime ? "scheduled" : "posted",
            },
            cardNumber,
            "linkedin"
          );
        }
        setopenSuccessModal("dismissible");
        setsuccessFailureMessage(response?.data?.message);
      } else {
        setopenFailureModal("dismissible");
        setsuccessFailureMessage(response?.data?.message);
      }
    } catch (error) {
      clog(error);
      if (error.response && error?.response?.status == 401) {
        localStorage.removeItem("login_token");
        localStorage.removeItem("login_data");
        navigate("/");
      }
      setopenFailureModal("dismissible");
      setsuccessFailureMessage(
        error?.response?.data?.message ||
          "Something went wrong, please try again later."
      );
    } finally {
      setPosting(false);
    }
  }
  const getRemarkableText = (text) => {
    // let string=stringOutput?.replaceAll(/\n/g, "<br/>");
    const md = new Remarkable();
    md.set({
      html: true,
      breaks: true,
      linkify: true,
      typographer: true,
      quotes: "“”‘’",
      xhtmlOut: true,
      langPrefix: "language-",
    });
    const html = md.render(text || "");
    return html;
  };
  useEffect(() => {
    // Cleanup function to clear the timer when the component unmounts
    return () => {
      if (typingTimer) {
        clearTimeout(typingTimer);
      }
    };
  }, [typingTimer]);

  useEffect(() => {
    let tempDiv = document.createElement("div");
    tempDiv.innerHTML = stringOutput;
    setTextLength(tempDiv.textContent.length);
  }, [stringOutput]);
  // useEffect(() => {
  //   if(tweet?.media&&Object.keys(tweet?.media||{})?.length>0){
  //     setMedia(tweet?.media);
  //   }

  // }, [tweet?.media])

  // useEffect(() => {
  //   if (mediaObj?.url && !loader) {
  //     setMedia(mediaObj);
  //     settweets((prev) => {
  //       let temp = [...prev];
  //       temp[cardNumber].media = mediaObj;
  //       return temp;
  //     });
  //   } else {
  //     setMedia(null);
  //     settweets((prev) => {
  //       let temp = [...prev];
  //       temp[cardNumber].media = null;
  //       return temp;
  //     });
  //   }
  // }, [mediaObj, loader]);

  const handleContentChange = (event) => {
    setUpdating(true);
    // clog(event.target.innerHTML, "event.target.innerHTML");
    // const updatedContent = event.target.innerHTML;
    // const updatedContent = wholeStringOutput?.replace(
    //   originalString,
    //   event.target.textContent
    // )
    setTextLength(event.target.textContent.length);
    const md = new Remarkable();
    md.set({
      html: true,
      breaks: true,
      linkify: true,
      typographer: true,
      quotes: "“”‘’",
      xhtmlOut: true,
      langPrefix: "language-",
    });
    const html = md.render(wholeStringOutput || "");
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    let listItems = doc.querySelectorAll("p");
    let updatedContent = "";
    if (listItems[cardNumber])
      listItems[cardNumber].textContent = event.target.textContent;
    updatedContent = doc.body.innerHTML;
    // clog(updatedContent, "updatedContent",originalString,'originalstring')
    // Clear the previous timer
    if (typingTimer) {
      clearTimeout(typingTimer);
    }

    // Set a new timer to call the save API after typingTimeout milliseconds
    const newTypingTimer = setTimeout(() => {
      // saveContentToApi(updatedContent, event);
    }, typingTimeout);

    setTypingTimer(newTypingTimer);
  };

  const saveContentToApi = async (content, event) => {
    if (content && content != "") {
      // clog('string outut updated')
      const selectedFile = JSON.parse(localStorage.getItem("selected_file"));
      let selected_file_data = {
        content_id: selectedFile?.content_id || selectedFile?.id || "",
        space_id: selectedFile?.space_id || "",
        folder_id: selectedFile?.folder_id || "",
      };
      let mediaArray = media_arr;
      if (event?.mediaObj?.url) {
        mediaArray[cardNumber] = event?.mediaObj;
      } else {
        mediaArray[cardNumber] = {};
      }
      let posted_tweets_arr =
        selectedFile?.content_settings?.posted_tweets_arr || [];
      posted_tweets_arr[cardNumber] = event?.tweetPosted || isTweetPosted;
      let selectedFileContentSettings = {
        ...selectedFile?.content_settings,
        media_arr: mediaArray,
        posted_tweets_arr: posted_tweets_arr,
      };
      selectedFileContentSettings["content_title"] =
        selectedFile?.content_title;
      selectedFileContentSettings["content_template"] =
        selectedFile?.content_template;
      await callUpdateToFileApi(
        selectedFileContentSettings,
        content,
        {},
        selected_file_data,
        selectedFile
      );
      setUpdating(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target)
        // && !contentEditableRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
        setSavedSelection(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pickerRef]);
  // Add this near your other state declarations
  // Update the preventScroll function
  const preventScroll = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    // Store current scroll position
    const scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    // Prevent any scroll events
    const preventScrolling = (e) => {
      window.scrollTo(0, scrollPosition);
      e.preventDefault();
      e.stopPropagation();
    };

    // Add temporary event listeners
    window.addEventListener("scroll", preventScrolling, { passive: false });
    window.addEventListener("touchmove", preventScrolling, { passive: false });

    // Remove event listeners after a short delay
    setTimeout(() => {
      window.removeEventListener("scroll", preventScrolling);
      window.removeEventListener("touchmove", preventScrolling);
    }, 100);
  }, []);
  clog(tweet, "tweet");

  return (
    <div className="w-[100] border-[1px] border-[#E9EBF0] p-[15px] bg-[#FAFBFC] rounded-[16px]">
      {headline === "Tweets" && profile && (
        <div className="flex items-center mb-4">
          <div className="w-[40px] h-[40px] flex items-center justify-center rounded-full overflow-hidden me-4">
            <img
              src={profile?.profile_image_url}
              className="w-full h-full object-cover"
              alt="avtar"
            />
          </div>
          <div className="">
            <p className="text-[#4D4E4E] text-[18px]">
              {profile?.social_name}
              {profile?.verified && (
                <svg className="icon text-[18px] text-blue-600 ms-2">
                  <use href="#icon_verify"></use>
                </svg>
              )}
            </p>
            <p className="text-[#A4A4A4]">@{profile?.username}</p>
          </div>
        </div>
      )}
      <div className="flex items-center gap-3 w-full p-2 border-b border-gray-300">
        <button
          className="font-extrabold text-[20px] px-3 py-1 rounded-md hover:bg-gray-200 transition"
          onClick={() => applyFormatting("bold")}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Bold"
          data-tooltip-place="bottom"
        >
          B
        </button>
        <button
          className="italic text-[20px] px-3 py-1 rounded-md hover:bg-gray-200 transition"
          onClick={() => applyFormatting("italic")}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Italic"
          data-tooltip-place="bottom"
        >
          I
        </button>
        <button
          className="font-bold italic text-[20px] px-3 py-1 rounded-md hover:bg-gray-200 transition"
          onClick={() => applyFormatting("boldItalic")}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Bold + Italic"
          data-tooltip-place="bottom"
        >
          B + I
        </button>
        <button
          className="underline text-[20px] px-3 py-1 rounded-md hover:bg-gray-200 transition"
          onClick={() => applyFormatting("underline")}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Underline"
          data-tooltip-place="bottom"
        >
          U
        </button>
        <button
          className="p-2 rounded-md hover:bg-gray-200 transition"
          onClick={insertBulletPoint}
          data-tooltip-id="my-tooltip"
          data-tooltip-content="List"
          data-tooltip-place="bottom"
        >
          <svg className="icon text-[28px]">
            <use href="#icon_list"></use>
          </svg>
        </button>
      </div>

      <div
        onInput={(e) => {
          setedited(true);
          handleContentChange({ ...e, mediaObj: media });
          settweetsModified((prev) => {
            return prev.map((item, index) => {
              if (index === cardNumber) {
                return {
                  ...item,
                  content: contentEditableRef.current.innerText,
                };
              }
              return item;
            });
          });
        }}
        contentEditable={!tweet?.id?.length > 0}
        ref={contentEditableRef}
        className="text-[#333] text-editor min-h-[120px] p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#388CC5]"
        onMouseUp={() => {
          const selection = window.getSelection();
          if (selection.rangeCount > 0) {
            setSavedSelection(selection.getRangeAt(0));
          }
        }}
        onBlur={(event) => {
          event.target.style.border = "initial";
          const text = event.target.textContent;
          if (
            previousSelection.current &&
            text.endsWith(previousSelection.current)
          ) {
            event.target.textContent = text.slice(
              0,
              text.length - previousSelection.current.length
            );
            previousSelection.current = null;
          }
        }}
        dangerouslySetInnerHTML={{
          __html: convertMarkdownToFormatted(stringOutput),
        }}
      />

      {tweet?.media?.url && (
        <div className="flex items-center my-4 ">
          <div className=" relative rounded-[10px] overflow-hidden ">
            {tweet?.media?.type == "image" ? (
              <img src={tweet?.media?.url} alt="images" />
            ) : (
              <video
                controls
                loop
                autoPlay
                muted
                controlsList="nodownload"
                onMouseOver={(e) => {
                  e.target.muted = false;
                  //make volume 10%
                  e.target.volume = 0.1;
                }}
                onMouseOut={(e) => {
                  e.target.muted = true;
                }}
                src={tweet?.media?.url}
              ></video>
            )}
            <button
              onClick={() => {
                setMedia(null);
                settweets((prev) => {
                  let temp = [...prev];
                  temp[cardNumber].media = null;
                  return temp;
                });
                handleContentChange({
                  target: contentEditableRef.current,
                  mediaObj: null,
                });
              }}
              disabled={posting || isTweetPosted}
              type="button"
              className="rounded-full  text-[16px] font-[700] bg-white bg-opacity-50 px-3  border-none absolute top-[10px] right-[10px]  hover:text-[#1A8CD1] hover:bg-opacity-100"
            >
              {headline === "Tweets" ? "X" : "LinkedIn"}
            </button>
          </div>
        </div>
      )}

      <div className="flex items-center my-4">
        <button
          disabled={posting || isTweetPosted}
          className="disabled:opacity-50"
          onClick={() => setImagesPopup("dismissible")}
        >
          <svg className="icon text-[22px]">
            <use href="#icon_image"></use>
          </svg>
        </button>

        <div className="w-[1px] h-full bg-[#E8EAED] mx-4">&nbsp;</div>

        {
          <Popover
            open={showEmojiPicker}
            // draggable={true}
            content={
              <div ref={pickerRef}>
                <EmojiPicker
                  autoFocusSearch={false}
                  // searchDisabled
                  previewConfig={{
                    showPreview: false,
                  }}
                  // open={showEmojiPicker}
                  // style={{
                  //   position: "absolute",
                  //   top: "-100px",
                  //   right: "400px",
                  // }}
                  skinTonesDisabled
                  emojiStyle={"native"}
                  onEmojiClick={(emojiObject) => {
                    if (savedSelection) {
                      savedSelection.deleteContents();
                      const textNode = document.createTextNode(
                        emojiObject.emoji
                      );
                      savedSelection.insertNode(textNode);
                      setSavedSelection(null);
                    }
                    setShowEmojiPicker(false);
                    handleContentChange({
                      target: contentEditableRef.current,
                      mediaObj: media,
                    });
                  }}
                />
              </div>
            }
          >
            <button
              onClick={(e) => {
                setShowEmojiPicker(!showEmojiPicker);
              }}
              disabled={!savedSelection || isTweetPosted}
              className="disabled:opacity-50"
            >
              <svg className="icon text-[22px]">
                <use href="#icon_smile"></use>
              </svg>
            </button>
          </Popover>
        }
        {headline === "Tweets" && (
          <p className={`text-[#A4A4A4] ms-auto `}>
            <span
              className={
                textLength > textLimit ? "text-red-500" : "text-inherit"
              }
            >
              {textLength}
            </span>
            /{textLimit}
          </p>
        )}
      </div>

      <div className="h-[1px] bg-[#E8EAED]"></div>

      <div className="flex items-center justify-between my-4">
        <button
          disabled={
            !contentEditableRef?.current?.textContent?.length ||
            posting ||
            (headline === "Tweets" && textLength > textLimit) ||
            tweet?.id?.length > 0
          }
          onClick={() => {
            // if (getPlanDetails() > 1) {
            if (profile) {
              postNewTweet(null, null);
            } else {
              setConnectModal("dismissible");
            }
            // } else {
            //   setshowModal({
            //     first: true,
            //     second: false,
            //     third: false,
            //   });
            //   setpopupMessage("post on X (Twitter).");
            // }
          }}
          type="button"
          className="disabled:opacity-50 bg-transparent text-[#2A2A2A] font-semibold hover:text-white py-2 px-4 border border-[#2A2A2A] hover:border-transparent rounded-full hover:bg-gradient-to-r from-[#547AF6] to-[#F74AE0] flex items-center justify-center w-1/2 me-3 hover:border-x-[0px]"
        >
          <svg className="icon me-3">
            {headline === "Tweets" ? (
              <use href="#icon_x"></use>
            ) : (
              <use href="#icon_linkedIn"></use>
            )}
          </svg>
          {posting
            ? "Posting..."
            : tweet?.type === "posted" && tweet?.id && "posted"
            ? `Posted On ${headline === "Tweets" ? "X (Twitter)" : "LinkedIn"}`
            : `Post On ${headline === "Tweets" ? "X (Twitter)" : "LinkedIn"}`}
        </button>

        <button
          disabled={
            !contentEditableRef?.current?.textContent?.length ||
            posting ||
            (headline === "Tweets" && textLength > textLimit) ||
            tweet?.id?.length > 0
          }
          onClick={() => {
            if (profile) {
              setSchedulePostModal("dismissible");
            } else {
              setConnectModal("dismissible");
            }
          }}
          type="button"
          className="disabled:opacity-50 bg-transparent text-[#2A2A2A] font-semibold hover:text-white py-2 px-4 border border-[#2A2A2A] hover:border-transparent rounded-full hover:bg-gradient-to-r from-[#547AF6] to-[#F74AE0] flex items-center justify-center w-1/2 ms-3 hover:border-x-[0px]"
        >
          <svg className="icon me-3">
            <use href="#icon_calendar"></use>
          </svg>
          {tweet?.type == "scheduled" ? "Added To Calendar" : "Add To Calendar"}
        </button>
      </div>
      <ScheduleSocialPostModal
        loading={posting}
        onConfirm={postNewTweet}
        schedulePostModal={schedulePostModal}
        setSchedulePostModal={setSchedulePostModal}
      />
      <PixelMediaPopup
        imagesPopup={imagesPopup}
        setImagesPopup={setImagesPopup}
        onSelect={(mediaData) => {
          setMedia(mediaData);
          settweets((prev) => {
            let temp = [...prev];
            temp[cardNumber].media = mediaData;
            return temp;
          });
          setImagesPopup(undefined);
          handleContentChange({
            target: contentEditableRef.current,
            mediaObj: mediaData,
          });
        }}
        headline={headline}
      />
      <Tooltip
        id="my-tooltip"
        place="bottom"
        delayShow={100}
        className="react-tooltip"
      />
    </div>
  );
}

export default TweetCard;
